export const CloseRedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#FF6768"
        d="M8 16c4.406 0 8-3.563 8-8 0-4.406-3.594-8-8-8-4.438 0-8 3.594-8 8 0 4.438 3.563 8 8 8zM5.469 5.469a.736.736 0 011.031 0l1.469 1.468L9.437 5.47c.313-.282.782-.282 1.063 0 .313.312.313.781 0 1.062L9.031 8 10.5 9.469c.313.312.313.781 0 1.062-.281.313-.75.313-1.063 0L7.97 9.062 6.5 10.533a.684.684 0 01-1.031 0c-.313-.282-.313-.75 0-1.063L6.937 8 5.47 6.531c-.313-.281-.313-.75 0-1.062z"
      ></path>
    </svg>
  );
};

export const SadFace = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 96C74.4375 96 96 74.625 96 48C96 21.5625 74.4375 0 48 0C21.375 0 0 21.5625 0 48C0 74.625 21.375 96 48 96ZM29.8125 72.9375C29.25 74.625 27.5625 75.375 26.0625 75C24.375 74.4375 23.625 72.75 24 71.25C27.1875 61.3125 36.75 54 48 54C59.0625 54 68.625 61.3125 71.8125 71.25C72.1875 72.75 71.4375 74.4375 69.75 75C68.25 75.375 66.5625 74.625 66 72.9375C63.75 65.625 56.625 60 48 60C39.1875 60 32.0625 65.625 29.8125 72.9375ZM39 39C39 42.375 36.375 45 33 45C29.625 45 27 42.375 27 39C27 35.8125 29.625 33 33 33C36.375 33 39 35.8125 39 39ZM63 45C59.625 45 57 42.375 57 39C57 35.8125 59.625 33 63 33C66.375 33 69 35.8125 69 39C69 42.375 66.375 45 63 45Z"
        fill="#B7ACCB"
      />
    </svg>
  );
};

export const PlayerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="7"
      fill="none"
      viewBox="0 0 7 7"
    >
      <path
        fill="#7F779E"
        d="M3.5 3.25c-.832 0-1.5-.668-1.5-1.5 0-.82.668-1.5 1.5-1.5.82 0 1.5.68 1.5 1.5 0 .832-.68 1.5-1.5 1.5zm-.54.563h1.067c1.16 0 2.098.937 2.098 2.097a.35.35 0 01-.352.34H1.215a.34.34 0 01-.34-.34c0-1.16.926-2.098 2.086-2.098z"
      ></path>
    </svg>
  );
};

export const PlayersIcon = (props: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={props.color || "#5B536F"}
        d="M4.5 7A2.468 2.468 0 012 4.5C2 3.125 3.094 2 4.5 2 5.875 2 7 3.125 7 4.5 7 5.906 5.875 7 4.5 7zM16 7a2.468 2.468 0 01-2.5-2.5C13.5 3.125 14.594 2 16 2c1.375 0 2.5 1.125 2.5 2.5C18.5 5.906 17.375 7 16 7zM0 11.344C0 9.5 1.469 8 3.313 8h1.343c.5 0 .969.125 1.407.313C6 8.53 6 8.78 6 9c0 1.219.5 2.281 1.344 3H.656A.64.64 0 010 11.344zM12.656 12h-.031c.844-.719 1.344-1.781 1.344-3 0-.219 0-.469-.031-.688A3.291 3.291 0 0115.312 8h1.344C18.5 8 20 9.5 20 11.344c0 .375-.313.656-.688.656h-6.656zM13 9a3 3 0 11-6.002-.002A3 3 0 0113 9zm-9 8.188C4 14.874 5.844 13 8.156 13h3.656A4.188 4.188 0 0116 17.188c0 .437-.375.812-.844.812H4.812A.807.807 0 014 17.187z"
      ></path>
    </svg>
  );
};

export const MoneyBagIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="15"
      fill="none"
      viewBox="0 0 12 15"
    >
      <path
        fill="#5B536F"
        d="M7.5 4.25h-3L3.375 2.586C3.211 2.352 3.398 2 3.68 2h4.617c.281 0 .469.352.305.586L7.5 4.25zM4.5 5h3c.07.07.188.14.305.21C9.117 6.056 12 7.884 12 11.75A2.25 2.25 0 019.75 14h-7.5A2.25 2.25 0 010 11.75c0-3.867 2.86-5.695 4.195-6.54.094-.07.211-.14.305-.21zm1.969 2.25A.47.47 0 006 6.781a.476.476 0 00-.492.469v.14c-.117.048-.235.07-.352.141-.351.14-.656.446-.75.867-.023.235 0 .47.094.68.094.211.258.352.398.469.282.187.633.281.915.375h.046c.329.117.54.187.68.281.07.047.094.07.094.094 0 .023.023.07 0 .164 0 .07-.047.14-.188.21-.14.048-.375.095-.68.048-.14-.024-.374-.117-.609-.188a.333.333 0 00-.14-.047.444.444 0 00-.586.282.478.478 0 00.28.609c.048 0 .071.023.118.023.188.07.469.165.703.211v.141c0 .281.211.492.469.492a.476.476 0 00.469-.492v-.117c.117-.024.234-.07.351-.117.375-.141.68-.446.75-.891a1.177 1.177 0 00-.07-.703 1.124 1.124 0 00-.398-.469c-.282-.21-.657-.328-.961-.422-.352-.094-.563-.164-.704-.258-.07-.046-.093-.07-.093-.093 0 0-.024-.024 0-.117 0-.047.047-.118.187-.188.164-.07.399-.094.68-.047.094 0 .422.07.516.094.234.07.492-.094.562-.328a.469.469 0 00-.328-.586c-.117-.024-.352-.07-.492-.094V7.25z"
      ></path>
    </svg>
  );
};

export const ArrowUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <path
        fill="#DCDAE0"
        d="M6.96 3.96l-4.5 4.5a.723.723 0 000 1.056.723.723 0 001.056 0L7.5 5.555l3.96 3.96a.723.723 0 001.056 0 .723.723 0 000-1.054l-4.5-4.5a.723.723 0 00-1.055 0z"
      ></path>
    </svg>
  );
};
export const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <path
        fill="#DCDAE0"
        d="M6.96 3.96l-4.5 4.5a.723.723 0 000 1.056.723.723 0 001.056 0L7.5 5.555l3.96 3.96a.723.723 0 001.056 0 .723.723 0 000-1.054l-4.5-4.5a.723.723 0 00-1.055 0z"
        transform="rotate(180 7.5 8)"
      ></path>
    </svg>
  );
};

export const ReBetIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      fill="none"
      viewBox="0 0 17 18"
    >
      <path
        fill="#FCFBFF"
        d="M.5 8c0-2.75 2.219-5 5-5h5V2c0-.375.219-.75.594-.906a1.01 1.01 0 011.094.218l2 2a.964.964 0 010 1.407l-2 2a1.01 1.01 0 01-1.094.218c-.375-.156-.594-.53-.594-.937V5h-5a3 3 0 00-3 3c0 .563-.469 1-1 1-.563 0-1-.438-1-1zm16 2c0 2.781-2.25 5-5 5h-5v1c0 .406-.25.781-.625.938a1.01 1.01 0 01-1.094-.22l-2-2a.964.964 0 010-1.405l2-2a1.01 1.01 0 011.094-.22c.375.157.625.532.625.907v1h5a3 3 0 003-3c0-.531.438-1 1-1 .531 0 1 .469 1 1z"
      ></path>
    </svg>
  );
};

export const RandomIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="17"
      fill="none"
      viewBox="0 0 21 17"
    >
      <path
        fill="#FCFBFF"
        d="M8.875.875l5.75 5.75c.469.5.469 1.281 0 1.781l-5.75 5.75c-.5.469-1.281.469-1.781 0l-5.75-5.75a1.304 1.304 0 010-1.781l5.75-5.75a1.304 1.304 0 011.781 0zM8.75 7.5A.76.76 0 008 6.75a.74.74 0 00-.75.75c0 .438.313.75.75.75a.74.74 0 00.75-.75zM4 8.25a.74.74 0 00.75-.75.76.76 0 00-.75-.75.74.74 0 00-.75.75c0 .438.313.75.75.75zm4 2.5a.74.74 0 00-.75.75c0 .438.313.75.75.75a.74.74 0 00.75-.75.76.76 0 00-.75-.75zm4-2.5a.74.74 0 00.75-.75.76.76 0 00-.75-.75.74.74 0 00-.75.75c0 .438.313.75.75.75zm-4-5.5a.74.74 0 00-.75.75c0 .438.313.75.75.75a.74.74 0 00.75-.75.76.76 0 00-.75-.75zM11 15v-1.563l4.313-4.343c.718-.688.843-1.75.437-2.594h3.75c.813 0 1.5.688 1.5 1.5v7a1.5 1.5 0 01-1.5 1.5h-7A1.48 1.48 0 0111 15zm5-2.75a.74.74 0 00.75-.75.76.76 0 00-.75-.75.74.74 0 00-.75.75c0 .438.313.75.75.75z"
      ></path>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      fill="none"
      viewBox="0 0 14 16"
    >
      <path
        fill="#FF6768"
        d="M4.219.563A.962.962 0 015.094 0h3.781c.375 0 .719.219.875.563L10 1h3c.531 0 1 .469 1 1 0 .563-.469 1-1 1H1c-.563 0-1-.438-1-1 0-.531.438-1 1-1h3l.219-.438zM13 4l-.688 10.594c-.03.812-.687 1.406-1.5 1.406H3.157c-.812 0-1.469-.594-1.5-1.406L1 4h12z"
      ></path>
    </svg>
  );
};

export const EraseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FF6768"
        d="M12.063 5.813a2.018 2.018 0 012.843 0l4.281 4.28a2.018 2.018 0 010 2.845L15.095 17H19c.531 0 1 .469 1 1 0 .563-.469 1-1 1H8.687a1.959 1.959 0 01-1.406-.563l-2.5-2.5a2.018 2.018 0 010-2.843l7.282-7.281zM12.28 17l2.094-2.094-4.281-4.281L6.188 14.5l2.5 2.5h3.593z"
      ></path>
    </svg>
  );
};

export const ChatIcon = (props: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20"
    >
      <path
        fill={props.color || "#5B536F"}
        d="M2.333 2h9c1.094 0 2 .906 2 2v6c0 1.125-.906 2-2 2H6.647l-2.531 1.906c-.157.125-.344.125-.532.063a.514.514 0 01-.25-.469V12h-1c-1.125 0-2-.875-2-2V4c0-1.094.875-2 2-2zm9 11a3 3 0 003-3V6h4c1.094 0 2 .906 2 2v6c0 1.125-.906 2-2 2h-1v1.5a.539.539 0 01-.28.469c-.188.062-.376.062-.532-.063L13.99 16h-3.656c-1.125 0-2-.875-2-2v-1h3z"
      ></path>
    </svg>
  );
};

export const HistoryIcon = (props: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      fill="none"
      viewBox="0 0 17 20"
    >
      <path
        fill={props.color || "#5B536F"}
        d="M3.01 4.344A7.982 7.982 0 018.666 2c4.407 0 8 3.594 8 8 0 4.438-3.593 8-8 8a8.227 8.227 0 01-4.593-1.406c-.438-.344-.563-.969-.25-1.407.312-.468.937-.562 1.406-.25C6.198 15.626 7.385 16 8.666 16c3.313 0 6-2.688 6-6 0-3.313-2.687-6-6-6a6.001 6.001 0 00-4.25 1.781l.97.938C5.853 7.219 5.51 8 4.853 8H1.416a.722.722 0 01-.75-.75V3.812c0-.656.782-1 1.282-.53L3.01 4.343zM8.666 6h-.03a.74.74 0 01.75.75v2.969l2.03 2.031a.684.684 0 010 1.031.684.684 0 01-1.03 0l-2.25-2.25c-.157-.125-.22-.312-.22-.531V6.75a.74.74 0 01.75-.75z"
      ></path>
    </svg>
  );
};

export const RankIcon = (props: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={props.color || "#5B536F"}
        d="M11.031 3.719l1.656.219a.37.37 0 01.188.624l-1.188 1.125.282 1.657c.062.281-.25.5-.531.375L10 6.937l-1.469.782A.371.371 0 018 7.344l.281-1.625-1.187-1.157c-.219-.218-.094-.593.187-.625l1.657-.218.718-1.5c.156-.281.531-.281.656 0l.72 1.5zM8 10h4c.531 0 1 .469 1 1v6c0 .563-.469 1-1 1H8c-.563 0-1-.438-1-1v-6c0-.531.438-1 1-1zm-7 2h4c.531 0 1 .469 1 1v4c0 .563-.469 1-1 1H1c-.563 0-1-.438-1-1v-4c0-.531.438-1 1-1zm13 3c0-.531.438-1 1-1h4c.531 0 1 .469 1 1v2c0 .563-.469 1-1 1h-4c-.563 0-1-.438-1-1v-2z"
      ></path>
    </svg>
  );
};

export const IoSend = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      fill="none"
      viewBox="0 0 18 16"
    >
      <path
        fill="#FB8111"
        d="M2.531.875l13.813 6c1 .438 1 1.844 0 2.281l-13.813 6c-1.062.469-2.156-.719-1.594-1.75l2.188-4.031a.86.86 0 01.688-.469l5.5-.687c.093 0 .187-.094.187-.219a.202.202 0 00-.188-.187l-5.5-.688a.86.86 0 01-.687-.469L.937 2.625C.375 1.594 1.47.406 2.532.875z"
      ></path>
    </svg>
  );
};

export const DashedLine = (props: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="2"
      fill="none"
      viewBox="0 0 120 2"
    >
      <path
        stroke="#3C3553"
        strokeDasharray="4 4"
        strokeLinecap="round"
        strokeWidth="2"
        d="M1 1L118.415 1"
      ></path>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#968EB0"
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z"
        clipRule="evenodd"
      ></path>
      <mask
        id="mask0_1776_412693"
        style={{ maskType: "alpha" }}
        width="16"
        height="16"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
      >
        <circle cx="10" cy="10" r="8" fill="#D9D9D9"></circle>
      </mask>
      <g mask="url(#mask0_1776_412693)">
        <path
          fill="#968EB0"
          d="M4 3h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H4c-1.125 0-2-.875-2-2V5c0-1.094.875-2 2-2zm3.469 4.469c-.313.312-.313.781 0 1.062L8.937 10 7.47 11.469c-.313.312-.313.781 0 1.062a.684.684 0 001.031 0l1.469-1.469 1.469 1.47c.312.312.78.312 1.062 0 .313-.282.313-.75 0-1.063L11.031 10 12.5 8.531c.313-.281.313-.75 0-1.062-.281-.282-.75-.282-1.063 0L9.97 8.937 8.5 7.47a.736.736 0 00-1.031 0z"
        ></path>
      </g>
      <rect
        width="18"
        height="18"
        x="1"
        y="1"
        stroke="#3C3553"
        strokeOpacity="0.4"
        strokeWidth="2"
        rx="9"
      ></rect>
    </svg>
  );
};

export const SavedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      fill="none"
      viewBox="0 0 12 17"
    >
      <path
        fill="#FCFBFF"
        d="M0 2A1.5 1.5 0 011.5.5h9c.813 0 1.5.688 1.5 1.5v13.75c0 .438-.344.75-.781.75a.717.717 0 01-.438-.125L6 13l-4.813 3.375a.717.717 0 01-.437.125.722.722 0 01-.75-.75V2z"
      ></path>
    </svg>
  );
};

export const PlusAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#0FC943"
        d="M8 16c-4.438 0-8-3.563-8-8 0-4.406 3.563-8 8-8 4.406 0 8 3.594 8 8 0 4.438-3.594 8-8 8zm-.75-5.25c0 .438.313.75.75.75a.74.74 0 00.75-.75v-2h2A.74.74 0 0011.5 8a.76.76 0 00-.75-.75h-2v-2A.76.76 0 008 4.5a.74.74 0 00-.75.75v2h-2A.74.74 0 004.5 8c0 .438.313.75.75.75h2v2z"
      ></path>
    </svg>
  );
};

export const CheckMark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      fill="none"
      viewBox="0 0 16 12"
    >
      <path
        fill="#22E54B"
        d="M14.688 1.313a.964.964 0 010 1.406l-8 8a.964.964 0 01-1.407 0l-4-4a.964.964 0 010-1.407.964.964 0 011.407 0L6 8.595l7.281-7.281a.964.964 0 011.406 0z"
      ></path>
      <path
        fill="#005415"
        d="M14.688 1.313l-.735.678.027.03.03.026.678-.735zm0 1.406l-.679-.735-.014.014-.015.014.707.707zm-8 8l-.708-.707-.014.014-.013.014.734.679zm-1.407 0l.735-.678-.014-.015-.014-.014-.707.707zm-4-4l.707-.707-.014-.014-.014-.014-.679.735zm0-1.407l.679.735.029-.027.027-.03-.735-.678zm1.407 0l-.735.679.015.016.016.016.704-.71zM6 8.595l-.704.71.707.7.704-.703L6 8.594zm7.281-7.281l.707.707.014-.015.014-.014-.735-.679zm.728.734a.062.062 0 01-.014-.02.03.03 0 01-.003-.011c0-.002 0-.006.003-.012a.062.062 0 01.014-.02l1.357 1.47a1.964 1.964 0 000-2.876l-1.357 1.47zm-.029-.035l-8 8 1.415 1.414 8-8-1.415-1.414zM5.953 10.04a.062.062 0 01.02-.014.03.03 0 01.011-.003.03.03 0 01.012.003.062.062 0 01.02.014l-1.47 1.357a1.964 1.964 0 002.876 0l-1.47-1.357zm.035-.028l-4-4L.574 7.426l4 4 1.414-1.414zM1.96 5.984a.06.06 0 01.014.02.03.03 0 01.003.012.03.03 0 01-.003.011.06.06 0 01-.014.02L.603 4.577a1.964 1.964 0 000 2.877l1.357-1.47zm.056.007a.06.06 0 01-.02.014.03.03 0 01-.012.003.03.03 0 01-.011-.003.06.06 0 01-.02-.014l1.47-1.357a1.964 1.964 0 00-2.877 0l1.47 1.357zm-.032.032l3.312 3.281 1.408-1.42L3.39 4.601l-1.407 1.42zM6.707 9.3l7.281-7.281L12.574.605 5.293 7.887 6.707 9.3zm7.31-7.31a.062.062 0 01-.021.014.029.029 0 01-.012.003.03.03 0 01-.011-.003.06.06 0 01-.02-.014l1.47-1.357a1.964 1.964 0 00-2.877 0l1.47 1.357z"
      ></path>
    </svg>
  );
};

export const DoubleCheckMark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#22E54B"
        d="M11.688 2.719l-5 5a.964.964 0 01-1.407 0l-2.5-2.5a.964.964 0 010-1.407.964.964 0 011.406 0L6 5.595l4.281-4.282a.964.964 0 011.406 0 .964.964 0 010 1.407zm3 4l-8 8a.964.964 0 01-1.407 0l-4-4a.964.964 0 010-1.406.964.964 0 011.407 0L6 12.592l7.281-7.28a.964.964 0 011.406 0 .964.964 0 010 1.406z"
      ></path>
      <path
        fill="#005415"
        d="M11.688 2.719l-.679-.735-.014.014-.015.014.707.707zm-5 5l-.708-.707-.014.014-.013.014.734.679zm-1.407 0l.735-.679-.014-.014-.014-.014-.707.707zm-2.5-2.5l.707-.707-.014-.014-.014-.014-.679.735zm0-1.407l.679.735.029-.027.027-.03-.735-.678zm1.406 0l-.734.679.016.018.018.017.7-.713zM6 5.595l-.7.713.706.695.701-.701L6 5.594zm4.281-4.282l.707.708.014-.015.014-.014-.735-.679zm1.406 0l-.734.679.027.03.03.026.678-.735zm3 5.407l-.678-.735-.014.014-.015.014.707.707zm-8 8l-.707-.707-.014.014-.013.014.734.679zm-1.406 0l.735-.678-.014-.015-.014-.014-.707.707zm-4-4l.707-.707-.014-.014-.014-.014-.679.735zm0-1.406l.679.734.029-.027.027-.03-.735-.678zm1.407 0l-.735.678.015.016.016.016.704-.71zM6 12.592l-.704.711.707.7.704-.703L6 12.594zm7.281-7.28l.707.707.014-.015.014-.014-.735-.678zm1.406 0l-.734.678.027.03.03.026.678-.734zM10.98 2.011l-5 5 1.415 1.414 5-5-1.415-1.414zM5.953 7.04a.06.06 0 01.02-.014.03.03 0 01.011-.003.03.03 0 01.012.003.06.06 0 01.02.014l-1.47 1.357a1.964 1.964 0 002.876 0L5.952 7.04zm.035-.028l-2.5-2.5-1.414 1.414 2.5 2.5 1.414-1.414zM3.46 4.484a.06.06 0 01.014.02.03.03 0 01.003.012.03.03 0 01-.003.011.06.06 0 01-.014.02l-1.357-1.47a1.964 1.964 0 000 2.877l1.357-1.47zm.056.007a.06.06 0 01-.02.014.03.03 0 01-.012.003.03.03 0 01-.011-.003.06.06 0 01-.02-.014l1.47-1.357a1.964 1.964 0 00-2.877 0l1.47 1.357zm-.03.035L5.3 6.307l1.402-1.426-1.813-1.782-1.401 1.427zM6.708 6.3l4.281-4.281L9.574.605 5.293 4.887 6.707 6.3zm4.31-4.31a.062.062 0 01-.021.014.029.029 0 01-.012.003.03.03 0 01-.011-.003.06.06 0 01-.02-.014l1.47-1.357a1.964 1.964 0 00-2.877 0l1.47 1.357zm-.008.056a.062.062 0 01-.014-.02.03.03 0 01-.003-.011c0-.002 0-.006.003-.012a.062.062 0 01.014-.02l1.357 1.47a1.964 1.964 0 000-2.876l-1.357 1.47zm2.971 3.965l-8 8 1.415 1.414 8-8-1.415-1.414zM5.953 14.04a.062.062 0 01.02-.015.03.03 0 01.011-.003.03.03 0 01.012.003.062.062 0 01.02.014l-1.47 1.357a1.964 1.964 0 002.876 0l-1.47-1.357zm.035-.03l-4-4-1.414 1.415 4 4 1.414-1.414zM1.96 9.985a.06.06 0 01.014.02l.003.012a.03.03 0 01-.003.011.06.06 0 01-.014.02L.603 8.577a1.964 1.964 0 000 2.877l1.357-1.47zm.056.007a.062.062 0 01-.02.014.03.03 0 01-.012.003.03.03 0 01-.011-.003.062.062 0 01-.02-.014l1.47-1.357a1.964 1.964 0 00-2.877 0l1.47 1.357zm-.032.032l3.312 3.281 1.408-1.42L3.39 8.601l-1.407 1.421zm4.723 3.278l7.281-7.281-1.414-1.415-7.281 7.282L6.707 13.3zm7.31-7.31a.062.062 0 01-.021.014.029.029 0 01-.012.003.03.03 0 01-.011-.003.06.06 0 01-.02-.014l1.47-1.357a1.964 1.964 0 00-2.877 0l1.47 1.357zm-.008.056a.062.062 0 01-.014-.02.03.03 0 01-.003-.011c0-.002 0-.006.003-.012a.062.062 0 01.014-.02l1.357 1.47a1.964 1.964 0 000-2.876l-1.357 1.47z"
      ></path>
    </svg>
  );
};
